module.exports = __webpack_public_path__ + "static/showreel2022_clip-fbc8a8b1f695eccdc65843f5fad42194.mp4";